<template>
  <div class="menu" v-scroll="handleScroll">
    <div class="menu-button">
      <transition
        enter-active-class="animate__animated animate__rotateIn"
        leave-active-class="animate__animated animate__rotateOut"
      >
        <button @click="menuShowed = true" v-if="!menuShowed">
          <font-awesome-icon class="menu-icon" icon="fa-solid fa-bars" />
        </button>
      </transition>
      <transition
        enter-active-class="animate__animated animate__rotateIn"
        leave-active-class="animate__animated animate__rotateOut"
      >
        <button @click="menuShowed = false" v-if="menuShowed">
          <font-awesome-icon class="menu-icon" icon="fa-solid fa-x" />
        </button>
      </transition>
      <div class="themes">
        thèmes |
        <a
          href="#"
          @click.prevent="updateTheme('flatui')"
          :class="theme == 'flatui' ? 'selected' : ''"
          >flatui</a
        >
        |
        <a
          href="#"
          @click.prevent="updateTheme('db')"
          :class="theme == 'db' ? 'selected' : ''"
          >dbz</a
        >
      </div>
      <div class="langues">
        <a
          href="#"
          @click.prevent="updateLang('fr')"
          :class="$i18n.locale == 'fr' ? 'selectedLang' : ''"
        >
          <img src="/img/flags/fr.gif" height="15px" />
        </a>
        <a
          href="#"
          @click.prevent="updateLang('en')"
          :class="$i18n.locale == 'en' ? 'selectedLang' : ''"
        >
          <img src="/img/flags/uk.webp" height="15px" />
        </a>
      </div>
    </div>
    <transition
      enter-active-class="opened_menu"
      leave-active-class="closed_menu"
    >
      <div v-if="menuShowed" class="menu-content">
        <a @click.prevent="scrollToAnchorPoint('vision')" href="#">{{ $t("menu.qui") }}</a>
        <a @click.prevent="scrollToAnchorPoint('jonathan')" href="#">{{ $t("menu.ref") }}</a>
        <a @click.prevent="scrollToAnchorPoint('services')" href="#">{{ $t("menu.services") }}</a>
        <a @click.prevent="scrollToAnchorPoint('contact')" href="#">{{ $t("menu.contact") }}</a>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FastLaneMenu",
  props: [],
  data: function () {
    return {
      menuShowed: false,
      menuButtonShowed: true,
      theme: "flatui",
    };
  },
  methods: {
    updateLang: function (lang) {
      this.$i18n.locale = lang;
    },
    updateTheme: function (theme) {
      this.theme = theme;
      if (theme == "db") {
        document.documentElement.style.setProperty(
          "--flatui-color1",
          "#1c4595"
        );
        document.documentElement.style.setProperty(
          "--flatui-color2",
          "#e76a24"
        );
        document.documentElement.style.setProperty(
          "--flatui-color3",
          "#5f2e37"
        );
        document.documentElement.style.setProperty(
          "--flatui-color4",
          "#e7e5e8"
        );
      } else if (theme == "flatui") {
        document.documentElement.style.setProperty(
          "--flatui-color1",
          "#1a365d"
        );
        document.documentElement.style.setProperty(
          "--flatui-color2",
          "#2c5282"
        );
        document.documentElement.style.setProperty(
          "--flatui-color3",
          "#2d3748"
        );
        document.documentElement.style.setProperty(
          "--flatui-color4",
          "#e2e8f0"
        );
        document.documentElement.style.setProperty(
          "--flatui-color5",
          "#3182ce"
        );
        document.documentElement.style.setProperty(
          "--flatui-color6",
          "#2b6cb0"
        );
        document.documentElement.style.setProperty(
          "--flatui-accent",
          "#ed8936"
        );
      }
    },
    handleScroll: function () {
      if (window.scrollY > 0 && this.menuShowed) {
        this.menuShowed = false;
      }
      return false;
    },
    scrollToAnchorPoint(refName) {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
      this.menuShowed = false;
      let el = document.getElementById(refName);
      setTimeout(() => {
        console.log("scroll ", refName, el.getBoundingClientRect().top, window.scrollY);
        window.scrollTo({top: el.getBoundingClientRect().top, behavior:'smooth'});
      }, 500);
    },
  },
};
</script>

<style scoped>
.menu {
  position: absolute;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 2rem;
  padding: 1rem;
  box-sizing: border-box;
  z-index: 100;
}
.themes {
  left: 1rem;
  position: absolute;
  font-size: 0.9rem;
  max-width: 30vw;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.langues {
  right: 1rem;
  position: absolute;
  font-size: 0.9rem;
  max-width: 30vw;
  display: flex;
  align-items: center;
}
.langues > a {
  padding-right: 5px;
}
.selectedLang > img {
  border: 2px solid var(--flatui-color5) !important;
  border-radius: 4px;
}
.themes > a {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}
.themes > a:hover {
  background: rgba(255,255,255,0.1);
}
.langues > a > img {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  border-radius: 4px;
  opacity: 0.7;
}
.langues > a > img:hover {
  opacity: 1;
  border-color: var(--flatui-color5);
}
.selected {
  font-weight: 600;
  text-decoration: none;
  border: 1px solid var(--flatui-color5);
  padding: 4px 8px;
  background: rgba(49, 130, 206, 0.2);
  border-radius: 6px;
  color: var(--flatui-color5);
}
@keyframes open-menu {
  0% {
    width: 0%;
    opacity: 0;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
}
.opened_menu {
  animation: open-menu 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.closed_menu {
  animation: open-menu 0.3s cubic-bezier(0.4, 0, 0.2, 1) reverse;
}
.menu-icon {
  font-size: 1.2rem;
}
a {
  margin: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--flatui-color4);
  font-style: normal;
  text-decoration: none;
  font-weight: 500;
}
.menu-content {
  margin-top: 4rem;
  height: 80vh;
  left: 0;
  right: 0;
  width: 90vw;
  bottom: 0;
  background: linear-gradient(135deg, var(--flatui-color3) 0%, #2d3748 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(20px);
}
button {
  position: absolute;
  height: 52px;
  width: 52px;
  border-radius: 50%;
  padding: 5px;
  background: rgba(255,255,255,0.95);
  color: var(--flatui-color3);
  border: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}
button:hover {
  transform: scale(1.1);
  cursor: pointer;
  box-shadow: 0 8px 25px rgba(0,0,0,0.3);
}
.menu-content>a:hover {
  font-size: 2.2rem;
  color: var(--flatui-color5);
  transform: translateX(10px);
  cursor: pointer;
}
</style>
